<template>
    <div style="overflow-y: hidden;">

        <header-nav :activeNav="activeNav" ref="headerNav"></header-nav>

        <full-page :options="fullpageOptions" ref="fullpage">
            <div class="section page1">
                <div class="container">
                    <video src="../assets/video.mp4" muted autoplay loop webkit-playsinline="true" x-webkit-airplay="true"
                        playsinline="true" x5-video-player-type="h5" x5-video-orientation="h5"
                        x5-video-player-fullscreen="true" poster="../assets/videoPoster.png" type="video/mp4"
                        id="videoPlayer"></video>
                    <img src="../assets/videoPoster.png" id="weixin">
                </div>
            </div>

            <div class="section page2" style="position: relative;">

                <div class="container">
                    <img src="../assets/img/home/productCenter/backgroundImage.png" class="bgImage">
                    <h2>产品中心</h2>
                    <div class="content_tab">
                        <ul>
                            <li>
                                <a @click="toSubNav(1, 1)" @mouseenter="activeProdTab = 1">
                                    <h4>工业质检行业专机</h4>
                                    <div class="liIcon">
                                        <img src="../assets/img/home/productCenter/industrialQualityInspection.png"
                                            v-show="activeProdTab != 1">
                                        <img src="../assets/img/home/productCenter/industrialQualityInspection-hover.png"
                                            v-show="activeProdTab == 1">
                                    </div>
                                    <p>为工业生产过程提供软硬一体标准化视觉检测解决方案</p>
                                </a>
                            </li>
                            <li>
                                <a @click="toSubNav(1, 5)" @mouseenter="activeProdTab = 2">
                                    <h4>智能模组系列</h4>
                                    <div class="liIcon">
                                        <img src="../assets/img/home/productCenter/intelligentModule.png"
                                            v-show="activeProdTab != 2">
                                        <img src="../assets/img/home/productCenter/intelligentModule-hover.png"
                                            v-show="activeProdTab == 2">
                                    </div>
                                    <p>覆盖工业视觉领域各长尾市场需求，提供高效、精准的视觉服务</p>
                                </a>
                            </li>
                            <li>
                                <a @click="toSubNav(1, 9)" @mouseenter="activeProdTab = 3">
                                    <h4>AI智能平台</h4>
                                    <div class="liIcon">
                                        <img src="../assets/img/home/productCenter/intelligentPlatform.png"
                                            v-show="activeProdTab != 3">
                                        <img src="../assets/img/home/productCenter/intelligentPlatform-hover.png"
                                            v-show="activeProdTab == 3">
                                    </div>
                                    <p>基于机器视觉，将人工智能、数字孪生技术赋能制造领域</p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="section page3" style="position: relative;">

                <div class="container">
                    <h2>核心技术</h2>
                    <div class="content_tab">
                        <div class="circle">
                            <img src="../assets/img/productCenter/subnav3/tab1/circle.svg">
                        </div>
                        <li @click="toSubNav(2, 1)" @mouseenter="activeTechTab = 1">
                            <img src="../assets/img/home/technicalAdvantages/liBgImage1.png" class="liBgImage"
                                v-show="activeTechTab != 1">
                            <img src="../assets/img/home/technicalAdvantages/liBgImage1-hover.png" class="liBgImage"
                                v-show="activeTechTab == 1">

                            <img src="../assets/img/home/technicalAdvantages/liIcon1.svg" class="liIcon">
                            <a>
                                <img src="../assets/img/home/technicalAdvantages/liBgImage1-icon.png"
                                    v-show="activeTechTab != 1">
                                <img src="../assets/img/home/technicalAdvantages/liBgImage1-icon-hover.png"
                                    v-show="activeTechTab == 1">
                                <h4>AutoML</h4>
                                <p>自动高效优化多环节使AI更智能 </p>
                            </a>
                        </li>
                        <li @click="toSubNav(2, 2)" @mouseenter="activeTechTab = 2">
                            <img src="../assets/img/home/technicalAdvantages/liBgImage2.png" class="liBgImage"
                                v-show="activeTechTab != 2">
                            <img src="../assets/img/home/technicalAdvantages/liBgImage2-hover.png" class="liBgImage"
                                v-show="activeTechTab == 2">

                            <img src="../assets/img/home/technicalAdvantages/liIcon2.svg" class="liIcon">
                            <a>
                                <img src="../assets/img/home/technicalAdvantages/liBgImage2-icon.png"
                                    v-show="activeTechTab != 2">
                                <img src="../assets/img/home/technicalAdvantages/liBgImage2-icon-hover.png"
                                    v-show="activeTechTab == 2">
                                <h4>可信赖AI</h4>
                                <p>有效降低算法误判</p>
                            </a>
                        </li>
                        <li @click="toSubNav(2, 4)" @mouseenter="activeTechTab = 3">
                            <img src="../assets/img/home/technicalAdvantages/liBgImage3.png" class="liBgImage"
                                v-show="activeTechTab != 3">
                            <img src="../assets/img/home/technicalAdvantages/liBgImage3-hover.png" class="liBgImage"
                                v-show="activeTechTab == 3">

                            <img src="../assets/img/home/technicalAdvantages/liIcon3.svg" class="liIcon">
                            <a>
                                <img src="../assets/img/home/technicalAdvantages/liBgImage3-icon.png"
                                    v-show="activeTechTab != 3">
                                <img src="../assets/img/home/technicalAdvantages/liBgImage3-icon-hover.png"
                                    v-show="activeTechTab == 3">
                                <h4>小样本学习</h4>
                                <p>降低模型对数据量依赖</p>
                            </a>
                        </li>
                        <li @click="toSubNav(2, 3)" @mouseenter="activeTechTab = 4">
                            <img src="../assets/img/home/technicalAdvantages/liBgImage4.png" class="liBgImage"
                                v-show="activeTechTab != 4">
                            <img src="../assets/img/home/technicalAdvantages/liBgImage4-hover.png" class="liBgImage"
                                v-show="activeTechTab == 4">

                            <img src="../assets/img/home/technicalAdvantages/liIcon4.svg" class="liIcon">
                            <a>
                                <img src="../assets/img/home/technicalAdvantages/liBgImage4-icon.png"
                                    v-show="activeTechTab != 4">
                                <img src="../assets/img/home/technicalAdvantages/liBgImage4-icon-hover.png"
                                    v-show="activeTechTab == 4">
                                <h4>主动学习</h4>
                                <p>提升标注效率，持续优化模型</p>
                            </a>
                        </li>
                    </div>
                </div>
            </div>

            <div class="section page4" style="position:relative;">

                <div class="container">
                    <img src="../assets/img/home/industryApplication/backgroundImage.png" class="bgImage">
                    <h2>行业应用</h2>
                    <div class="content_tab">
                        <li :class="{ active: activeAppTab == 1 }" @mouseenter="activeAppTab = 1" @click="toSubNav(3, 1)">
                            <img src="../assets/img/home/industryApplication/liBgImage1-hover.png" class="liBgImage_hover"
                                v-show="activeAppTab == 1">
                            <img src="../assets/img/home/industryApplication/liBgImage1.png" class="liBgImage">
                            <h4>半导体晶圆</h4>
                            <img src="../assets/img/home/industryApplication/liIcon1.png" class="liIcon"
                                v-show="activeAppTab !== 1">
                            <p v-show="activeAppTab == 1">场景可覆盖晶圆生产、制造、封测各环节的检测需求</p>
                        </li>
                        <li :class="{ active: activeAppTab == 2 }" @mouseenter="activeAppTab = 2" @click="toSubNav(3, 2)">
                            <img src="../assets/img/home/industryApplication/liBgImage2-hover.png" class="liBgImage_hover"
                                v-show="activeAppTab == 2">
                            <img src="../assets/img/home/industryApplication/liBgImage2.png" class="liBgImage">
                            <h4>电子元器件</h4>
                            <img src="../assets/img/home/industryApplication/liIcon2.png" class="liIcon"
                                v-show="activeAppTab !== 2">
                            <p v-show="activeAppTab == 2">涵盖PCBA制造SMT及DIP制程中的各项检测需求</p>
                        </li>
                        <li :class="{ active: activeAppTab == 3 }" @mouseenter="activeAppTab = 3" @click="toSubNav(3, 3)">
                            <img src="../assets/img/home/industryApplication/liBgImage3-hover.png" class="liBgImage_hover"
                                v-show="activeAppTab == 3">
                            <img src="../assets/img/home/industryApplication/liBgImage3.png" class="liBgImage">
                            <h4>新能源电池</h4>
                            <img src="../assets/img/home/industryApplication/liIcon3.png" class="liIcon"
                                v-show="activeAppTab !== 3">
                            <p v-show="activeAppTab == 3">提供锂电池制造从电芯到模组多工艺各流程的检测方案</p>
                        </li>
                        <li :class="{ active: activeAppTab == 4 }" @mouseenter="activeAppTab = 4" @click="toSubNav(3, 4)">
                            <img src="../assets/img/home/industryApplication/liBgImage4-hover.png" class="liBgImage_hover"
                                v-show="activeAppTab == 4">
                            <img src="../assets/img/home/industryApplication/liBgImage4.png" class="liBgImage">
                            <h4>太阳能光伏</h4>
                            <img src="../assets/img/home/industryApplication/liIcon4.png" class="liIcon"
                                v-show="activeAppTab !== 4">
                            <p v-show="activeAppTab == 4">涵盖太阳能光伏电池片生产制造环节内的各种定位、检测、识别等解决方案</p>
                        </li>
                    </div>
                </div>
            </div>

            <div class="section page5" style="position:relative;">

                <foot :activeNav="activeNav"></foot>

            </div>
        </full-page>

    </div>
</template>

<script>
import HeaderNav from '@/components/Header.vue'
import Foot from '@/components/Footer.vue'

import 'video.js/dist/video-js.css'

export default {
    name: 'Home',
    components: {
        HeaderNav,
        Foot,

    },
    data() {
        return {
            activeNav: 0,
            activeProdTab: null,
            activeTechTab: null,
            activeAppTab: 0,
            fullpageOptions: {
                afterLoad: function (anchorLink, index) {
                    if (index.index == 0 || index.index == 2) {
                        document.getElementsByTagName('header')[0].className = 'light'
                    } else {
                        document.getElementsByTagName('header')[0].className = ''
                    }
                },
                keyboardScrolling: false,
                autoScrolling: true,
            },
            screenWidth: window.innerWidth,
        }
    },
    mounted() {
        this.fullpageOptions.autoScrolling = this.screenWidth < 1170 ? false : true
        document.getElementById('videoPlayer').play()
        if (/MicroMessenger/.test(navigator.userAgent)) {
            document.getElementById('videoPlayer').play()
        }
        document.addEventListener("WeixinJSBridgeReady", function () {
            document.getElementById('videoPlayer').play()
        }, false);
        document.addEventListener('touchstart', function () {
            document.getElementById('videoPlayer').play()
        });
        document.getElementById('videoPlayer').addEventListener('pause', function () {
            document.getElementById('videoPlayer').play()
        });
        window.onresize = () => {
            return (() => {
                this.screenWidth = window.innerWidth
                this.$refs.headerNav.wapNav = false
            })();
        };
    },
    watch: {
        screenWidth(val) {
            this.fullpageOptions.autoScrolling = val < 1170 ? false : true
            // immediate: true
        },
    },
    methods: {
        toSubNav(nav, subNav) {
            this.$refs.headerNav.toSubNav(nav, subNav)
        },
    }
}
</script>

<style scoped>
.section {
    overflow: hidden;
}

.page1 .container {
    width: 100%;
    height: 100%;
    position: relative;
}

.page1 .container::before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 800;
    background-color: rgba(5, 11, 39, 0.3);
}

.page1 .container video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.page1 .container img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    display: none;
}

.page2 {
    width: 100%;
}

.page2 .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    position: relative;
    padding: calc(8.33vh + 80px) 7.8vw 12.68vh;
}

.page2 .container .bgImage {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -100;
    display: block;
}

.page2 .container h2 {
    font-family: 'SourceHanSansSC-Bold';
    font-size: 7.4vh;
    line-height: 8.14vh;
    color: #FFFFFF;
    text-align: center;
}

.page2 .container .content_tab {
    width: 100%;
    height: 51.2vh;
    margin-top: 10.3vh;
    overflow: hidden;
}

.page2 .container .content_tab ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}

.page2 .container .content_tab li {
    width: 27.39vw;
    height: 100%;
    padding: 7.4vh 2.08vw 6.2vh;
    position: relative;
    box-sizing: border-box;
    background: linear-gradient(180deg, rgba(70, 97, 233, 0.56) 0%, rgba(61, 76, 153, 0.56) 100%);
    border-radius: 0.62vw;
}

.page2 .container .content_tab li h4 {
    font-family: 'SourceHanSansSC-Bold';
    font-size: 3.7vh;
    line-height: 5.18vh;
    color: #E5E9FF;
    white-space: nowrap;
    text-align: center;
}

.page2 .container .content_tab li .liIcon {
    margin: 4.62vh auto 3.33vh;
    width: 18.5vh;
    height: 18.5vh;
}

.page2 .container .content_tab li img {
    width: 100%;
    height: 100%;
    display: block;
}

.page2 .container .content_tab li p {
    font-family: 'SourceHanSansSC-Regular';
    font-size: 2.22vh;
    line-height: 3.14vh;
    color: #CCD5FF;
}

.page2 .container .content_tab li:hover {
    background: linear-gradient(179.65deg, #4E69EE 0.25%, #2D349E 99.65%);
    border-radius: 0.62vw;
}

.page3 {
    background-color: #FAFBFF;
}

.page3 .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    position: relative;
    padding: 17.5vh 7.8vw 9.9vh;
}

.page3 .container h2 {
    font-family: 'SourceHanSansSC-Bold';
    font-size: 7.4vh;
    line-height: 8.14vh;
    color: #000419;
    text-align: center;
}

.page3 .container .content_tab {
    width: 59.9vw;
    height: 58.3vh;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    justify-content: space-between;
    align-content: space-between;
    flex-wrap: wrap;
    margin: 6.48vh auto;
    box-sizing: border-box;
}

.page3 .container .content_tab li {
    width: 27.08vw;
    height: 27.7vh;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
}

.page3 .container .content_tab li .liBgImage {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: block;
}

.page3 .container .content_tab li .liIcon {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 2.08vw;
    display: block;
    z-index: 100;
    width: 6.98vw;
    height: 4.79vw;
}

.page3 .container .content_tab li:nth-of-type(1) .liIcon,
.page3 .container .content_tab li:nth-of-type(3) .liIcon {
    right: 3.64vw;
}

.page3 .container .content_tab li:nth-of-type(2) .liIcon,
.page3 .container .content_tab li:nth-of-type(4) .liIcon {
    left: 3.64vw;
}

.page3 .container .content_tab li a {
    position: absolute;
    top: 2.08vw;
    z-index: 100;
    display: block;
    width: calc(100% - 7.28vw);
}

.page3 .container .content_tab li:nth-of-type(1) a,
.page3 .container .content_tab li:nth-of-type(3) a {
    left: 3.64vw;
}

.page3 .container .content_tab li a img {
    width: 8.3vh;
    height: 8.3vh;
}

.page3 .container .content_tab li h4 {
    font-family: 'SourceHanSansSC-Bold';
    font-size: 3.7vh;
    line-height: 5.18vh;
    color: #000419;
    white-space: nowrap;
}

.page3 .container .content_tab li:nth-of-type(2) a,
.page3 .container .content_tab li:nth-of-type(4) a {
    right: 3.43vw;
    text-align: right;
}

.page3 .container .content_tab li:nth-of-type(2) h4,
.page3 .container .content_tab li:nth-of-type(4) h4 {
    text-align: right;
}

.page3 .container .content_tab li:nth-of-type(2) p,
.page3 .container .content_tab li:nth-of-type(4) p {
    text-align: justify;
    display: inline-block;
}

.page3 .container .content_tab li p {
    margin-top: 2.03vh;
    font-family: 'SourceHanSansSC-Regular';
    font-size: 2.22vh;
    line-height: 3.14vh;
    color: #000D4D;
}

.page3 .container .content_tab .circle {
    position: absolute;
    top: calc(50% - 6.6vw);
    left: calc(50% - 6.6vw);
    width: 13.2vw;
    height: 13.2vw;
    z-index: 200;
}

.page3 .container .content_tab .circle img {
    width: 100%;
    height: 100%;
    display: block;
}

.page4 {
    width: 100%;
}

.page4 .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    position: relative;
    padding: 17.5vh 7.8vw 9.9vh;
}

.page4 .container .bgImage {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -200;
    display: block;
}

.page4 .container h2 {
    font-family: 'SourceHanSansSC-Bold';
    font-size: 7.4vh;
    line-height: 10.09vh;
    color: #FFFFFF;
    text-align: center;
}

.page4 .container .content_tab {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    box-sizing: border-box;
    height: 51.2vh;
    margin-top: 8.3vh;
}

.page4 .container .content_tab li {
    width: 17.3vw;
    height: 100%;
    padding: 0 2.96vw 0 2.5vw;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
}

.page4 .container .content_tab li .liBgImage,
.page4 .container .content_tab li .liBgImage_hover {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -100;
    display: block;
}

.page4 .container .content_tab li .liBgImage_hover {
    z-index: -10;
}

.page4 .container .content_tab li.active {
    width: 29.3vw;
}

.page4 .container .content_tab li.active h4 {
    text-align: left;
}

.page4 .container .content_tab li h4 {
    font-family: 'SourceHanSansSC-Bold';
    font-size: 3.7vh;
    line-height: 5.18vh;
    color: #FFFFFF;
    margin-top: 13.5vh;
    text-align: center;
}

.page4 .container .content_tab li .liIcon {
    width: 10.7vh;
    height: 10.7vh;
    margin: 5.92vh auto 0;
    display: block;
}

.page4 .container .content_tab li p {
    font-family: 'SourceHanSansSC-Regular';
    font-size: 2.22vh;
    line-height: 3.14vh;
    color: #FFFFFF;
    margin-top: 7.03vh;
}

.page4 .container .content_tab li::after {
    content: "";
    width: 3.32vw;
    height: 0.1vw;
    position: absolute;
    bottom: 6.48vh;
    left: calc(50% - 1.66vw);
    display: block;
    background-color: #FFFFFF;
}

.page4 .container .content_tab li.active::after {
    width: 10.4vw;
    left: 2.5vw;
}

.page5 {
    width: 100%;
}


@media only screen and (max-width:1350px) {
    header .logo {
        margin-left: 13vw;
    }

    .page2 .container {
        padding: calc(5.45vh + 80px) 13vw 8.6vh;
    }

    .page2 .container .content_tab {
        width: 100%;
        height: 69.4vh;
        margin-top: 6.43vh;
    }

    .page2 .container .content_tab ul {
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        align-content: space-between;
        flex-wrap: wrap;
    }

    .page2 .container .content_tab li {
        width: 100%;
        height: 21.8vh;
        padding: 4.84vh 1.56vw 4.84vh 20.3vw;
    }

    .page2 .container .content_tab li h4 {
        text-align: left;
    }

    .page2 .container .content_tab li .liIcon {
        position: absolute;
        top: calc(50% - 6.06vh);
        left: calc(10.15vw - 6.06vh);
        width: 12.12vh;
        height: 12.12vh;
        margin: 0;
    }

    .page2 .container .content_tab li p {
        margin-top: 1.03vh;
    }

    .page3 .container {
        box-sizing: border-box;
        height: 100%;
        width: 100%;
        position: relative;
        padding: calc(5.45vh + 80px) 13vw 26.9vh;
    }

    .page3 .container .content_tab {
        padding: 0;
        width: 69.75vh;
        height: 38.18vh;
        margin: 18.18vh auto;
    }

    .page3 .container .content_tab li {
        width: 31.5vh;
        height: 18.18vh;
    }

    .page3 .container .content_tab li a {
        top: 2.42vh;
    }

    .page3 .container .content_tab li a img {
        width: 5.23vh;
        height: 5.23vh;
    }

    .page3 .container .content_tab li h4 {
        font-size: 2.42vh;
        line-height: 3.39vh;
    }

    .page3 .container .content_tab li p {
        margin-top: 1.3vh;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 1.45vh;
        line-height: 2.06vh;
    }

    .page3 .container .content_tab .circle {
        top: calc(50% - 7.12vh);
        left: calc(50% - 7.12vh);
        width: 14.24vh;
        height: 14.24vh;
    }

    .page4 .container {
        padding: calc(2vh + 80px) 13vw 8.6vh;
    }

    .page4 .container .content_tab {
        /* width: 69.69vw; */
        width: 100%;
        height: 68.12vh;
        margin: 5.2vh auto;
        flex-wrap: wrap;
    }

    .page4 .container .content_tab li {
        width: calc(50% - 1.3vw);
        height: calc(50% - 1.3vh);
        padding: 0 3.03vh 0 3.33vh;
        box-sizing: border-box;
        margin-right: 1.3vw;
        margin-bottom: 1.3vh;
    }

    .page4 .container .content_tab li.active {
        width: calc(50% - 22px);
    }

    .page4 .container .content_tab li h4 {
        font-size: 2.42vh;
        line-height: 3.27vh;
        margin-top: 8.84vh;
    }

    .page4 .container .content_tab li .liIcon {
        width: 7.03vh;
        height: 7.03vh;
        margin: 4.42vh auto 0;
    }

    .page4 .container .content_tab li p {
        font-size: 1.45vh;
        line-height: 2.06vh;
        margin-top: 4.6vh;
    }

    .page4 .container .content_tab li::after {
        content: "";
        width: 3.88vh;
        height: 0.1vw;
        position: absolute;
        bottom: 5.51vh;
        left: calc(50% - 1.94vh);
        display: block;
        background-color: #FFFFFF;
    }

    .page4 .container .content_tab li.active::after {
        width: 12.12vh;
        left: 3.03vh;
    }

}

@media only screen and (max-width:1170px) {
    header .logo {
        margin-left: 5.98vw;
    }

    .page2 .container,
    .page3 .container,
    .page4 .container {
        padding-left: 5.98vw;
        padding-right: 5.98vw;
    }

    .page2 .container .content_tab {
        margin-top: 0;
    }

    .page2 .container .content_tab ul {
        align-content: start;
    }

    .page2 .container .content_tab li {
        height: 18vh;
        padding: 4.84vh 1.56vw 4.84vh calc(5.12vw + 8vh);
        margin-top: 2vh;
    }

    .page2 .container .content_tab li h4 {
        font-size: 3.2vh;
        line-height: 1;
        margin-top: 0;
    }

    .page2 .container .content_tab li p {
        font-size: 2vh;
        line-height: 2.6vh;
    }

    .page2 .container .content_tab li .liIcon {
        width: 8vh;
        height: 8vh;
        left: 2.56vw;
        top: calc(50% - 4vh);
    }

    .page3 .container .content_tab {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        align-content: center;
    }

    .page3 .container .content_tab li {
        width: 50%;
    }

    .page3 .container .content_tab li a {
        height: calc(100% - 4.84vh);
    }

    .page3 .container .content_tab .circle {
        top: calc(50% - 6vh);
        left: calc(50% - 6vh);
        width: 12vh;
        height: 12vh;
    }

    .page3 .container .content_tab li .liIcon {
        top: 2.42vh;
        width: 8.12vh;
        height: 5.57vh;
    }

    .page3 .container .content_tab li:nth-of-type(1) .liIcon,
    .page3 .container .content_tab li:nth-of-type(3) .liIcon {
        right: 3.64vw;
    }

    .page3 .container .content_tab li:nth-of-type(2) .liIcon,
    .page3 .container .content_tab li:nth-of-type(4) .liIcon {
        left: 3.64vw;
    }

    .page3 .container .content_tab li p {
        text-overflow: initial;
        white-space: normal;
        height: 100%;
    }

    .page3 .container .content_tab li:nth-of-type(2) p,
    .page3 .container .content_tab li:nth-of-type(4) p {
        text-align: left;
    }

    .page4 .container .content_tab {
        height: 52vh;
    }

    .page4 .container .content_tab li {
        width: calc(50% - 1.3vw);
        height: 50%;
    }

    .page4 .container .content_tab li.active {
        width: calc(50% - 1.3vw);
    }

    .page4 .container .content_tab li h4 {
        margin-top: 5vh;
    }

    .page4 .container .content_tab li .liIcon {
        margin-top: 2vh;
    }

    .page4 .container .content_tab li p {
        margin-top: 2vh;
    }

    .page4 .container .content_tab li::after {
        bottom: 5vh;
    }

    .page5 {
        background-color: #060C28;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue